import { VehicleRowGroup } from 'src/pages/ConvenienceDispatches/adapter';

/**
 * カードの探索を「選択していた勤務」に閉じる。
 *
 * Why 勤務で絞る: 1 台のトラックに複数のドライバーが乗る勤務では、各ドライバーの
 * shift_truck が別の delivery になり、回転番号は**勤務ごとに 1 から**振られる
 * (vehicleRowVM.ts の deliveryRowCandidates)。このとき積地カードの id
 * (`loading-${truckId}-${rotation}-${placeKey}-${index}`) は delivery を含まないため
 * **勤務をまたいで衝突する** (adapter.ts の loadingCardId)。id だけで全勤務を探すと、
 * 先に並ぶ別勤務の行を拾ってしまう。
 *
 * 降地カードの id は legRun を含む (`lr-${truckId}-${rotation}-${legRunId}`) ので衝突
 * しないが、固定ルート由来の noDelivery カードは積地と同じく delivery を含まない。
 *
 * Why not vehicle.id だけで絞る: vehicle.id は truck 単位 (`truck-${truckId}`) なので、
 * 同じトラックの複数勤務が同じ id を持つ。勤務が分かるときは shiftTruckId で引く
 * (detailSelectionSync.ts の findSameStopInVehicle と同じ規則)。
 */
export function scopeGroupsToVehicle(
  vehicle: VehicleRowGroup['vehicle'],
  rowGroups: readonly VehicleRowGroup[],
): VehicleRowGroup[] {
  // shiftTruckId は「回転を追加」の仮想行 (placeholder) では null になるため、
  // 引けないときだけ truck 単位へ落とす
  if (vehicle.shiftTruckId != null) {
    return rowGroups.filter((g) => g.vehicle.shiftTruckId === vehicle.shiftTruckId);
  }
  return rowGroups.filter((g) => g.vehicle.id === vehicle.id);
}

/**
 * 勤務の同一性キー。選択・トグル・応答待ちの照合で「どの勤務の話か」を区別するために使う。
 *
 * Why 必要: 積地カードの id は勤務をまたいで衝突し（上記 Why 参照）、**積地の
 * dispatchOrderIndex は必ず 0**（buildOperationPlaces.ts）なので、id と orderIndex を
 * 合わせても別勤務の積地を区別できない (logposeTech/log_web_issues#320)。
 *
 * shiftTruckId が引けない仮想行では truck 単位へ落とす（scopeGroupsToVehicle と同じ規則）。
 */
export function vehicleScopeKey(vehicle: VehicleRowGroup['vehicle']): string {
  return vehicle.shiftTruckId != null ? `st-${vehicle.shiftTruckId}` : `v-${vehicle.id}`;
}
